import { createContext } from 'react';
import { UIContextProps } from './UIProvider.types';

export const UIContext = createContext<UIContextProps>({
  appVariant: '',
});
